





































import { Component, Prop, Vue } from 'vue-property-decorator';

import CoinsIcon from '@/components/icons/CoinsV2.vue';
import InfoIcon from '@/components/icons/Info.vue';

@Component({
  components: {
    CoinsIcon,
    InfoIcon
  }
})
export default class CustomerWallet extends Vue {
  @Prop(String) availableBalance!: string;
  @Prop(String) pendingCoins!: string;
  @Prop(String) totalSpent!: string;
  @Prop(String) lastTransaction!: string;

  get currencySymbol() {
    return this.$store.getters['internationalization/getCountrySettings']
      .currencySymbol;
  }

  get tooltipText() {
    if (!this.lastTransaction) return '';

    return `Date: ${this.lastTransaction}`;
  }
}
